import React from "react";
import Types from "prop-types";
import { withRouter } from "react-router-dom";
import { ARGUS_APM } from "../../apm";
import eventAnalytics from "../../analytikaV2";
import { ANALYTIKA_EVENTS } from "../../utils/constants";
import LoadingSpinner from "../LoadingSpinner";
import MotInvitation from "./MotInvitation";
import MotInviteSwitchAccount from "./MotInviteSwitchAccount";
import { getUserinfo, validateInvitation } from "../gateway/InvitationGateway";

const STORAGE_KEY = "last_invitation_code";
const RESTORE_TOKEN = "restore_last_session";

const VIEWS = {
  LOADING: "loading",
  INVITATION: "invitation",
  WRONG_ACCOUNT: "wrong_account",
};

class MotInvitationGate extends React.Component {
  constructor(props) {
    super(props);

    const token = this.props.match.params.token;

    if (token !== RESTORE_TOKEN) {
      sessionStorage.setItem(STORAGE_KEY, token);
    }

    this.state = {
      view: VIEWS.LOADING,
      token,
    };
  }

  async componentDidMount() {
    if (this.state.token === RESTORE_TOKEN) {
      const savedCode = sessionStorage.getItem(STORAGE_KEY);
      if (savedCode) {
        this.props.history.replace(`/invitation/${savedCode}`);
        return;
      }
    }

    await this.checkInvitationOwnership();
  }

  componentDidUpdate(prevProps) {
    const prevToken = prevProps.match.params.token;
    const newToken = this.props.match.params.token;
    if (prevToken !== newToken && prevToken === RESTORE_TOKEN) {
      sessionStorage.setItem(STORAGE_KEY, newToken);
      this.setState({ token: newToken }, () => this.checkInvitationOwnership());
    }
  }

  async checkInvitationOwnership() {
    try {
      eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_SEND_WEBREQUEST, {
        request_type: "invitation_userinfo",
      });
      const { data } = await getUserinfo();
      eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_SEND_WEBRESPOSE, {
        request_type: "invitation_userinfo",
        request_status: "success",
      });

      const identifier = data.userkind === "merchant" ? data.email : data.phone_number;

      eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_SEND_WEBREQUEST, {
        request_type: "invitation_validate",
      });
      const isOwner = await validateInvitation({
        code: this.state.token,
        identifier,
      });
      eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_SEND_WEBRESPOSE, {
        request_type: "invitation_validate",
        request_status: "success",
      });

      this.setState({ view: isOwner ? VIEWS.INVITATION : VIEWS.WRONG_ACCOUNT });
    } catch (error) {
      ARGUS_APM.captureError(error);
      eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_SEND_WEBRESPOSE, {
        request_type: "invitation_ownership_check",
        request_status: "failed",
      });
      // Fall through to the invitation view and let MotInvitation handle the error
      this.setState({ view: VIEWS.INVITATION });
    }
  }

  render() {
    const { view } = this.state;

    switch (view) {
      case VIEWS.WRONG_ACCOUNT:
        return <MotInviteSwitchAccount />;
      case VIEWS.INVITATION:
        return <MotInvitation {...this.props} />;
      default:
        return <LoadingSpinner />;
    }
  }
}

MotInvitationGate.propTypes = {
  match: Types.object.isRequired,
  history: Types.object.isRequired,
};

export default withRouter(MotInvitationGate);
export const MotInvitationGateUnwrapped = MotInvitationGate;
